<template>
	<div class="page contact">
		<!-- Contact Banner -->
		<div class="contact-banner">
			<div class="contact-banner-img">
				<img :src="bannerList[0]?.img || require('../../assets/contact/serve.png')" alt=""></img>
			</div>
			<div class="carousel-information" @click="openInquiryForm">
				<img src="../../assets/home/xinxi.png" alt="">
			</div>
		</div>
		<!-- CONTACT US -->
		<div class="contact-us">
			<div class="area-title-mobile">
				<p class="area-titleTop-mobile">{{ $t('content.title') }}</p>
			</div>
			<!-- CONTACT US FORM -->
			<div class="contact-form">
				<div class="contact-form-cont">
					<div class="contact-form-form">
						<form>
							<div class="form-group">
								<label>{{ $t('content.follow.form.label.know') }}</label>
								<el-select v-model="formData.question_type_id" :placeholder="$t('error.select')" style="width: 100%;">
                                    <el-option v-for="op in knowOPtions" :key="op.id" :label="op.name"
                                        :value="op.id">
                                    </el-option>
                                </el-select>
							</div>
							<!-- <div class="form-group">
								<label>{{ $t('content.follow.form.label.identity') }}</label>
								<el-select v-model="formData.body_option" :placeholder="$t('error.select')" style="width: 100%;">
                                    <el-option v-for="op in bodyOPtions" :key="op.value" :label="op.label"
                                        :value="op.value">
                                    </el-option>
                                </el-select>
							</div> -->
							<div class="form-group">
								<label>{{ $t('content.follow.form.label.fullname') }}</label>
								<input class="form-control" v-model="formData.full_name" type="text" :placeholder="$t('home.inquiryCont.form.a3')">
							</div>
							<div class="form-group">
								<label>{{ $t('content.follow.form.label.contact') }}</label>
								<input class="form-control" type="text" v-model="formData.mobile" :placeholder="$t('home.inquiryCont.form.a4')">
							</div>
							<div class="form-group">
								<label>{{ $t('content.follow.form.label.email') }}</label>
								<input class="form-control" type="email" v-model="formData.email" :placeholder="$t('home.inquiryCont.form.a5')">
							</div>
							<!-- <div class="form-group">
								<label>{{ $t('home.inquiryCont.form.q6') }}:</label>
								<input class="form-control" type="text" :placeholder="$t('home.inquiryCont.form.a6')">
							</div> -->
							<!-- <div class="form-group">
								<label>{{ $t('content.follow.checkboxGroup.title') }}</label>
								<div class="form-check" v-for="check in checkOptions" :key="check.id">
                                    <input class="form-check-input" type="checkbox" v-model="formData.problem" :value="check.id">
                                    <label class="form-check-label" for="defaultCheck1">
                                       {{ check.name }}
                                    </label>
                                </div>
							</div> -->

							<!-- <div class="contact-form-btn button--ujarak">
								{{ $t('home.inquiryCont.form.submit') }}
							</div> -->
							<button type="submit" class="submit-button" @click.prevent="submit">
								{{ $t('home.inquiryCont.form.submit') }}
							</button>
							<!-- <div class="contact-form-note">
								Note：{{ $t('home.inquiryCont.form.note') }}
							</div> -->
						</form>
					</div>
				</div>

			</div>
		</div>

		<!-- Contact Bottom -->
		<div class="contact-bottom">
			<div class="contact-bottom-text">{{ $t('content.info.tip') }}</div>
			<div class="contact-info">
				<div class="contact-info-item">
					<div class="item-image">
						<img src="../../assets/contact/phone.png" alt=""></img>
					</div>
					<div class="item-text">{{ information?.mobile || $t('content.info.hotline') }}</div>
				</div>
				<div class="contact-info-item">
					<div class="item-image">
						<img src="../../assets/contact/address.png" alt=""></img>
					</div>
					<div class="item-text">{{ information?.address || $t('content.info.address') }}</div>
				</div>
				<div class="contact-info-item">
					<div class="item-image">
						<img src="../../assets/contact/email.png" alt=""></img>
					</div>
					<div class="item-text">{{ information?.email || $t('content.info.email') }}</div>
				</div>
			</div>
			<div class="contact-info-other">
				<div class="contact-info-other-text">{{ $t('content.follow.title') }}</div>
				<div class="contact-info-other-icon">
					<div class="contact-info-other-icon-div">
						<img src="../../assets/bottom-f.png" alt="">
						</img>
						<a :href="information?.facebook"></a>
					</div>
					<div class="contact-info-other-icon-div">
						<img src="../../assets/bottom-in.png" alt=""></img>
						<a :href="information?.linkedIn"></a>
					</div>
					<div class="contact-info-other-icon-div">
						<img src="../../assets/bottom-p.png" alt=""></img>
						<a :href="information?.twitter"></a>
					</div>
					<div class="contact-info-other-icon-div contact-info-other-icon-div-last">
						<img src="../../assets/bottom-x.png" alt=""></img>
						<a :href="information?.instagram"></a>
					</div>
					<div class="contact-info-other-icon-line"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { bus } from '@/utils/bus';
import { getDataList, getBannerListingMobile,getQuestionType,submitQuestion,getSolveOption ,getConfigInformation} from '@/api/komo.js';
export default {
	data() {
		return {
			knowOPtions:[],
            bodyOPtions:this.$t('content.follow.identityOPtions'),
            checkOptions:[],
            formData: {
                question_type_id:'',
                // body_option:'',
                full_name:'',
                mobile:'',
                email:'',
                // preferred_city:'',
                // problem:[]
            },
			bannerList: [],
			pageData: [],
			information:{}
		}
	},
	methods: {
		// 初始化表单选择项数据
    async initData(){
			const res = await getBannerListingMobile('9')
			if (res.error == 0) {
				this.bannerList = res?.data?.list || [];
			}
			const res1 = await getDataList(localStorage.getItem('pageId'))
			this.pageData = res1?.data?.list || []

            getQuestionType().then(res=>{ 
                this.knowOPtions = res?.data?.list
            })
            getSolveOption().then(res=>{ 
                this.checkOptions = res?.data?.list
            })
			getConfigInformation().then(res=>{ 
                this.information = res?.data
            })
        },
		async submit() {
            if (!this.formData.question_type_id) {
                this.$message.error(this.$t('error.select'))
                return;
            }
            // 校验身份
            // if (this.formData.body_option ===''|| this.formData.body_option == null) {
            //     this.$message.error(this.$t('error.select'))
            //     return;
            // }
            // 校验名字
            if (!this.formData.full_name) {
                this.$message.error(this.$t('error.name'))
                return;
            }

            // 校验手机号
            if (!this.formData.mobile) {
                this.$message.error(this.$t('error.phone'))
                return;
            }
            if (!this.validatePhone(this.formData.mobile)) {
                this.$message.error(this.$t('error.phoneFormat'))
                return;
            }
            // 校验邮箱
            if (!this.formData.email) {
                this.$message.error(this.$t('error.email'))
                return;
            }
            if (!this.validateEmail(this.formData.email)) {
                this.$message.error(this.$t('error.emailFormat'))
                return;
            }
            
            // 校验checkbox
            // if (!this.formData.problem.length >0 ) {
            //     this.$message.error(this.$t('error.select'))
            //     return;
            // }
            const params = {
							question_type_id: this.formData.question_type_id,
								body_option: "consumer",
                // body_option: this.formData.body_option === 0 ? "consumer" : "franchisee",
                full_name: this.formData.full_name,
                mobile: this.formData.mobile,
                email: this.formData.email,
                // preferred_city: this.formData.preferred_city,
                // problem: this.formData.problem
            }
            // console.log('submit123', params)
            const res = await submitQuestion(params)
            if (res?.error === 0) {
							this.$message.success(res?.message)
								this.formData =  {
									question_type_id: '',
									full_name: '',
									mobile: '',
									email: '',
								}
            } else {
                this.$message.error(res?.message)
            }

        },
        //验证手机号格式
        validatePhone(phone) {
            // 验证手机号是否为纯数字
            const numberRegex = /^1[34578]\d{9}$/;
            return numberRegex.test(phone);
        },
        //验证邮箱格式
        validateEmail(email) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(email);
        },
		openInquiryForm(){
             bus.$emit('inquiry-form', true)
        },
		onSubmit() {
			if (!this.form.name || !this.form.contact) {
				alert('请填写姓名与联系方式');
				return;
			}
			alert('提交成功，我们将在48小时内联系您');
			this.form = { topic: 'After sales demand', body: 'Consumer', name: '', contact: '', email: '', problems: [] };
		}
	},
	async created(){
		this.initData()
	}
}
</script>
<style scoped>
.contact {
	background: #F8F9FC;
}

/* Contact Banner */
.contact-banner {
	width: 100%;
	position: relative;
}

.contact-banner .contact-banner-img {
	width: 100%;
}

.contact-banner-img img {
	width: 100%;
	height: 100%;
}

.contact-banner .carousel-information {
	position: fixed;
    bottom: 3%;
    right: 3%;
    width: 25vw;
    height: 25vw;
    cursor: pointer;
    z-index: 999;
}

.contact-banner .carousel-information img {
	width: 100%;
	height: 100%;
}

/* CONTACT US */
/* KOMO Inquiry */
.contact-form {
	width: 100%;
	background: #FFFFFF;
	padding-top: 5%;
}

.contact-form-bottom {
	width: 100%;
	height: 90vh;
}

.contact-form-cont {
	width: 100%;
}

.contact-form-title {
	margin: 0;
	padding: 8% 0 5% 0;
	text-align: center;
	font-weight: bold;
	font-size: 2rem;
	color: #1E1E1E;
}

.contact-form-form {
	background: #FFFFFF;
	padding: 10px;
	border-radius: 20px;
}

.contact-form-form form{
	display: flex;
  flex-direction: column;
  gap: 3vh;	
}

/* form 表单 */
/* .form-group {
	margin-bottom: 5.33vw;
}

.form-group label {
	font-size: 3.73vw;
	color: #333;
	margin-bottom: 2.67vw;
	font-weight: 500;
}

.form-input,
.form-select {
	width: 100%;
	padding: 4.27vw;
	border: 0.27vw solid #E0E0E0;
	border-radius: 2.67vw;
	font-size: 3.73vw;
	color: #333;
	background-color: #fff;
	box-sizing: border-box;
	outline: none;
	transition: border-color 0.3s ease;
}

.form-input:focus,
.form-select:focus {
	border-color: #4A90E2;
}

.form-input::placeholder {
	color: #999;
	font-size: 3.73vw;
}

.form-select {
	appearance: none;
	background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
	background-repeat: no-repeat;
	background-position: right 3.2vw center;
	background-size: 4.27vw;
	padding-right: 10.67vw;
	cursor: pointer;
}

.form-select option {
	padding: 2.67vw;
	font-size: 3.73vw;
}

.form-check-input {
	font-size: 3.73vw;
} */

.submit-button {
	width: 22vh;
  padding: 2vw 3vw;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 10.67vw;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-button:hover {
	background-color: #555;
}

.submit-button:active {
	background-color: #222;
}

/* .form-group {
	padding: 2% 0;
}

.form-group label {
	padding-bottom: 2%;
} */

.contact-form-btn {
	width: 150px;
	height: 40px;
	border-radius: 20px;
	border: 1px solid #979797;
	font-size: 1rem;
	color: #FFFFFF;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	background-color: #1e1e1e;
	margin-top: 2%;
}

.contact-form-note {
	padding-top: 20px;
	font-family: MicrosoftYaHei;
	font-size: 1rem;
	color: #959595;
}

/* Contact Bottom */
.contact-bottom {
	width: 100%;
	padding: 30px 20px;
}

.contact-bottom-text {
	text-align: center;
	font-size: 1rem;
}

.contact-info {
	width: 100%;
	padding: 20px 0 0 0;
}

.contact-info-item {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 10px 0;
}

.contact-info-item .item-image {
	width: 6%;
	height: 6%;
	flex-shrink: 0;
}

.contact-info-item .item-image img {
	width: 100%;
	height: 100%;
}

.contact-info-item .item-text {
	padding-left: 10px;
}

.contact-info-other {
	width: 100%;
}

.contact-info-other-text {
	font-family: MicrosoftYaHei, MicrosoftYaHei;
	font-weight: bold;
	font-size: 25px;
	color: #252323;
	line-height: 60px;
	text-align: left;
	font-style: normal;
}

.contact-info-other-icon {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	padding: 10px 0 20px 0;
	gap: 2%;
}
.contact-info-other-icon-div{
	width: 10%;
	height: 100%;
	position: relative;
}
.contact-info-other-icon-div-last{
	margin-right: 10%;
}

.contact-info-other-icon img {
	width:100%;
	height:100%;
}
.contact-info-other-icon a{
	width: 100%;
	height: 100%;
	position: absolute;
	top:0;
	left: 0;
	z-index: 10;
}

.contact-info-other-icon-line {
	width: 15%;
	height: 1px;
	border: 1px solid #1E1E1E;
}

/* 多媒体自适应 样式 */
/* 1280 1080   */
@media (max-width: 1280px)and (min-width: 960px) {
	.form-check-input {
		margin-right: 10px;
	}
}
</style>
